export default __webpack_public_path__ + "static/media/Jenna_Young_AHV_In_Moms_We_Trust.f45f283e.jpg";